<template>
  <sTooltip
    :border="false"
    :content="$t('Tenders.Winner')"
    data-qa="bidder-is-winner-tooltip"
    placement="bottom"
    type="white">
    <sIcon
      class="bidder-is-winner"
      :color="color"
      data-qa="bidder-is-winner"
      size="12"
      type="person-check"/>
  </sTooltip>
</template>

<script>
export default {
  name: 'bidderIsWinner',
  props: {
    color: {
      type: String,
      default: 'var(--green_chosen)'
    }
  }
}
</script>
